import React from 'react';
import { useFormikContext } from 'formik';
import styles from './CarouselForm.module.scss';

import RadioGroup from 'component/atom/forms/radio-group/RadioGroup';
import UploadFile from 'component/atom/forms/upload-file/UploadFile';
import Input from 'component/atom/forms/input/input/Input';
import TextArea from 'component/atom/forms/text-area/TextArea';
import Button from 'component/atom/forms/button/Button';
import fileToBase64 from 'helpers/fileToBase64';
import ExpandableContainer from 'component/molecules/expandable-cont/ExpandableContainer ';

const CarouselForm = ({ allowedExtensions }) => {
  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormikContext();

  if (!values.details) {
    setFieldValue('details', []);
  }

  const handleAddCard = () => {
    setFieldValue('details', [
      ...(values.details || []),
      {
        uploadOrUrl: 'upload',
        fileName: '',
        blobUrl: '',
        cardTitle: '',
        cardDescription: '',
        file: null,
      },
    ]);
  };

  const handleRemoveCard = (index) => {
    if (values.details?.length > 0) {
      setFieldValue(
        'details',
        values.details.filter((_, i) => i !== index)
      );
    }
  };

  return (
    <form
      className="formCont"
      onSubmit={handleSubmit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      {values.details?.map((card, index) => {
        const cardErrors = errors.details?.[index] || {};
        const cardTouched = touched.details?.[index] || {};
        return (
          <ExpandableContainer
            key={index}
            title={`Card ${index + 1}`}
            isOpenInitially={index === 0}
            onDelete={() => handleRemoveCard(index)}
          >
            <div className={styles['form-content']}>
              {/* <RadioGroup
                name={`details[${index}].uploadOrUrl`}
                selectedValue={card.uploadOrUrl}
                onChange={(e) =>
                  setFieldValue(`details[${index}].uploadOrUrl`, e.target.value)
                }
                options={[
                  { value: 'upload', label: 'Upload' },
                  { value: 'url', label: 'Add URL' },
                ]}
                error={cardErrors.uploadOrUrl}
                touched={cardTouched.uploadOrUrl}
              /> */}

              <>
                {card.blobUrl || card?.file !== null ? (
                  <div className={styles.imageCont}>
                    <img
                      src={
                        card.blobUrl
                          ? card.blobUrl
                          : `data:image/png;base64,${card?.file.fileContent}`
                      }
                      alt="image"
                      className={styles.image}
                    />
                    <div className={styles['content-image']}>
                      <Button
                        label="Remove"
                        variant="#C81111"
                        onClick={() => {
                          setFieldValue(`details[${index}].file`, null);
                          setFieldValue(`details[${index}].blobUrl`, '');
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <UploadFile
                    title="Image"
                    name={`details[${index}].file`}
                    value={card?.file?.fileName || ''}
                    onChange={async (event) => {
                      if (!event.target.value) return;
                      const file = event.target.value;

                      if (!file) return;

                      setFieldValue(`details[${index}].file`, file);

                      setFieldValue(`details[${index}].blobUrl`, '');

                      try {
                        const fileData = await fileToBase64(file);
                        setFieldValue(`details[${index}].file`, {
                          fileName: file.name,
                          contentType: file.type,
                          fileContent: fileData.fileContent,
                        });
                      } catch (error) {
                        console.error('File processing error:', error);
                      }
                    }}
                    onBlur={handleBlur}
                    error={cardErrors.file}
                    touched={cardTouched.file}
                    allowedExtensions={allowedExtensions}
                    type="Image"
                  />
                )}
              </>

              {/* <Input
                  name={`details[${index}].blobUrl`}
                  placeholder="Enter URL"
                  value={card.blobUrl || ''}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={cardErrors.blobUrl}
                  touched={cardTouched.blobUrl}
                /> */}

              <Input
                name={`details[${index}].cardTitle`}
                label="Card Title"
                placeholder="Enter Title"
                value={card.cardTitle || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={cardErrors.cardTitle}
                touched={cardTouched.cardTitle}
              />

              <TextArea
                name={`details[${index}].cardDescription`}
                label="Card Description"
                placeholder="Enter Description (Optional)"
                value={card.cardDescription || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={cardErrors.cardDescription}
                touched={cardTouched.cardDescription}
              />
            </div>
          </ExpandableContainer>
        );
      })}

      <Button
        type="button"
        label="Add More"
        width="100%"
        onClick={handleAddCard}
      />
    </form>
  );
};

export default CarouselForm;
